module.exports = __webpack_public_path__ + "static/media/login_logo.50d8398d.svg";